export enum BillingMethodEnum {
    Invalid = 0,  
    PerReview = 1,
    PerCompetition = 2
  }
    